var indentation_default = {
  "indentZero": "uUTdd",
  "indentOne": "Lkq7f",
  "indentTwo": "lkN7H",
  "indentThree": "wOryX",
  "indentFour": "hlXzR",
  "indentFive": "noU0i",
  "indentSix": "JoFk0"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
